import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IChangeManagerPayload } from '../types';
import {
  AFFILIATES_APPROVED_PERMISSIONS,
  AFFILIATES_LIST_QUERY_KEY,
  CHANGE_MANAGER_API_URL,
  CHANGE_MANAGER_MUTATION_KEY,
} from '../constants';

export default function useChangeManagerMutation(): IContextMutationResult<void, Error, IChangeManagerPayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IChangeManagerPayload>({
    mutationKey: [CHANGE_MANAGER_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      CHANGE_MANAGER_API_URL,
      payload,
      { permission: AFFILIATES_APPROVED_PERMISSIONS.CHANGE_MANAGER_FOR_AFFILIATES },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATES_LIST_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
